export default ['/mina-sidor', '/login', '/auth/login'];
